import { Link } from "@hdir/ui/link";
import React from "react";
import type { LinkButtonProps } from "./LinkButton.d";

export function LinkButton(props: Readonly<LinkButtonProps>) {
  const {
    text,
    url,
    variant,
    position
  } = props;

  const positionClass = {
    left: "text-left",
    right: "text-right",
    center: "text-center"
  }[position];

  return (
    <div className={positionClass}>
      <Link
        className={`${variant !== "tertiary" ? "tablet:!py-sm tablet:!px-md tablet:!text-md" : ""}`}
        href={url}
        variant={variant === "tertiary" ? "normal" : `button-${variant ?? "secondary"}`}
        size="small"
      >
        {text}
      </Link>
    </div>
  );
}
